import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';
import { ThreadList } from '@/components/chats/thread-list';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/(app)/productivity/chats')({
  component: ChatsLayout,
});

function ChatsLayout() {
  // Whether a specific thread is open (the `$threadId` child route is active).
  const params = useParams({ strict: false }) as { threadId?: string };
  const hasThread = Boolean(params.threadId);

  return (
    // Landscape (tablet landscape + desktop): two columns - a fixed-width
    // thread list beside the chat window. Portrait (phones + tablet portrait):
    // a single pane - the list, or the open thread (WhatsApp-style master/detail
    // with a back button in the thread header).
    <div className="grid gap-6 landscape:grid-cols-[24rem_minmax(0,1fr)]">
      <div className={cn(hasThread && 'portrait:hidden')}>
        <ThreadList />
      </div>
      <div className={cn('min-w-0', !hasThread && 'portrait:hidden')}>
        <Outlet />
      </div>
    </div>
  );
}
